import {CreateSlice} from 'base'

export interface ProfileSlice {
  coordinatorTabKey: string

  setCoordinatorTabKey: (key: string) => void
}

const createProfileSlice: CreateSlice<ProfileSlice> = (set) => ({
  coordinatorTabKey: 'request',

  setCoordinatorTabKey: (coordinatorTabKey) => set(() => ({coordinatorTabKey})),
})

export default createProfileSlice
